
import React, { useState } from 'react';
import AssignmentModal from './modals/AssignmentModal';
import QuizModal from './modals/QuizModal';
import GlossaryModal from './modals/GlossaryModal';
import MaterialModal from './modals/MaterialModal';
import AnnouncementModal from './modals/AnnouncementModal';
import DemoAssignmentModal from './modals/DemoAssignmentModal';
import ProgramOutcomeModal from './modals/ProgramOutcomes';

export type ContentType = 'assignment' | 'quiz' | 'glossary' | 'material' | 'announcement' | 'co/po';

interface ContentCreationSystemProps {
  activeModal: ContentType | null;
  onCloseModal: () => void;
  onContentCreated: (type: ContentType, data: any) => void;
  modules: any[],
  subjectId: string,
  students: string[]
}

const ContentCreationSystem: React.FC<ContentCreationSystemProps> = ({
  activeModal,
  onCloseModal,
  onContentCreated,
  modules,
  subjectId,
  students
}) => {
  const handleContentSubmit = (type: ContentType, data: any) => {
    console.log(`Created ${type}:`, data);
    onContentCreated(type, data);
    
    // Show success notification
    showNotification(`${type.charAt(0).toUpperCase() + type.slice(1)} created successfully!`, 'success');
  };

  const showNotification = (message: string, type: 'success' | 'error') => {
    // Simple notification system - could be enhanced with a toast library
    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 z-[100] px-6 py-3 rounded-lg shadow-lg text-white font-medium transition-all duration-300 ${
      type === 'success' ? 'bg-green-600' : 'bg-red-600'
    }`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    // Animate in
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
      notification.style.opacity = '1';
    }, 100);
    
    // Remove after 3 seconds
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      notification.style.opacity = '0';
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  };

  return (
    <>
      {/* Assignment Modal */}
      <AssignmentModal
       modules={modules}
      subjectId={subjectId}
        isOpen={activeModal === 'assignment'}
        onClose={onCloseModal}
        onSubmit={(data) => handleContentSubmit('assignment', data)}
      />

      {/* Quiz Modal */}
      <QuizModal
        modules={modules}
        subjectId={subjectId}
        isOpen={activeModal === 'quiz'}
        onClose={onCloseModal}
        onSubmit={(data) => handleContentSubmit('quiz', data)}
      />

      {/* Glossary Modal */}
      <GlossaryModal
        modules={modules}
        subjectId={subjectId}
        isOpen={activeModal === 'glossary'}
        onClose={onCloseModal}
        onSubmit={(data) => handleContentSubmit('glossary', data)}
      />

      {/* Material Modal */}
      <MaterialModal
        isOpen={activeModal === 'material'}
        onClose={onCloseModal}
        onSubmit={(data) => handleContentSubmit('material', data)}
        subjectId={subjectId}
        modules={modules}
      />

      {/* Announcement Modal */}
      <AnnouncementModal
        isOpen={activeModal === 'announcement'}
        onClose={onCloseModal}
        onSubmit={(data) => handleContentSubmit('announcement', data)}
        subjectId={subjectId}
        modules={modules}
      />

      {/* Demo Assignment*/}
      <DemoAssignmentModal
      isOpen={activeModal === 'assignment'}
      onClose={onCloseModal}
      subjectId={subjectId}
      modules={modules}
      students={students}
      />

    {/* CO || PO */}
    <ProgramOutcomeModal
    isOpen={activeModal === 'co/po'}
    onClose={onCloseModal}
    subjectId={subjectId}
    />
    </>
  );
};

export default ContentCreationSystem;
